/** The plan-input fact keys (builder `definition.inputs`) — the live form values are read under these. */
export const DEFAULT_INPUT_KEYS: Record<string, string> = {
  cashPrice: "Payment Plan.Cash Price",
  downPayment: "Payment Plan.Down Payment (20%)",
  tenorYears: "Payment Plan.Tenor (years)",
  frequency: "Payment Plan.Installment Frequency",
  leadingMonths: "Payment Plan.Special Installments Count",
  // §Modal-only (product ask, 2026-08-05): Commercial/Residential is edited INSIDE the plan
  // modal only, and the derived Loan Amount displays there beside its inputs — neither renders
  // on the step card anymore.
  propertyUsage: "Payment Plan.Property Usage",
  loanAmount: "Payment Plan.Loan Amount",
};

/**
 * §Modals: the submission keys the payment-plan widget owns. StepForm uses this to find (and stop
 * rendering) the plan's input section, which the "Preview payment plan" modal renders instead.
 */
export const paymentPlanInputKeys = (
  parameters?: Record<string, unknown>
): string[] => {
  const configured = (parameters as { inputKeys?: Record<string, string> } | undefined)
    ?.inputKeys;
  return Object.values({ ...DEFAULT_INPUT_KEYS, ...(configured ?? {}) });
};

